import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@slal/ui/theme-provider';
import { BrowserRouter } from 'react-router';
import { ScrollToTop } from '~/components';
import { client } from '~/graphql';
import { AnalyticsProvider } from '~/providers';
import { AppRoutes } from '~/routes';

const App = () => {
    return (
        <ApolloProvider client={client}>
            <ThemeProvider>
                <BrowserRouter>
                    <AnalyticsProvider>
                        <ScrollToTop />
                        <AppRoutes />
                    </AnalyticsProvider>
                </BrowserRouter>
            </ThemeProvider>
        </ApolloProvider>
    );
};

export default App;
